import { defineElement, html, TemplateElement } from '@webtides/element-js';
import { when } from '@webtides/element-js/src/dom-parts/directives';

/**
 * @property {string} templateId
 * @property {boolean} needsCookieConsent
 * @property {string} cookieConsentGroup
 */
export default class HtmlComponent extends TemplateElement {
    constructor() {
        super({ shadowRender: true });
    }
    properties() {
        return {
            templateId: '',
            needsCookieConsent: false,
            cookieConsentGroup: 'C0001',
            consented: false,
        };
    }
    connected() {
        if (this.needsCookieConsent) {
            this.updateCookieConsent();
        } else {
            this.showContent();
        }
    }

    updateCookieConsent() {
        if (window.OptanonActiveGroups && window.OptanonActiveGroups.includes(this.cookieConsentGroup)) {
            this.showContent();
        } else {
            this.showConsentBanner();
        }
    }

    showContent() {
        this.consented = true;
        const template = document.getElementById(this.templateId);
        this.appendChild(template.content);
    }

    showConsentBanner() {
        this.consented = false;

        const slot = this.$refs.defaultSlot;
        if (slot) {
            const assignedNodes = slot.assignedNodes({ flatten: true });

            assignedNodes.forEach((node) => {
                node.remove();
            });
        }
    }

    events() {
        return {
            window: {
                OneTrustGroupsUpdated: () => {
                    this.updateCookieConsent();
                },
            },
            document: {
                'optanon-ready': () => {
                    this.updateCookieConsent();
                },
            },
        };
    }

    template() {
        return `${when(this.consented === true, html` <slot ref="defaultSlot"></slot> `, html` <slot name="consentBanner"> </slot>`)} `;
    }
}

defineElement('mb-html-component', HtmlComponent);
